export default "__VITE_ASSET__BpOAhN_9__"